import { IDV360TicketsInsertionOrder } from '@/Interfaces/DV360Tickets/InsertionOrder.interface';
import { DV360_TICKETS_INSERTION_ORDERS_ENDPOINT } from '@/constants/endpoints';
import axios from 'axios';

export const duplicateDV360TicketsInsertionOrder = async (
  id: number,
  name: string,
): Promise<IDV360TicketsInsertionOrder> => {
  const res = await axios.post(`${DV360_TICKETS_INSERTION_ORDERS_ENDPOINT}/${id}/duplicate`, { name });
  return res.data;
};
